export const ROLE_LABELS = {
  admin: "Administrator",
  vanzari: "Vânzări",
  asistent_vanzari: "Asistent Vânzări",
  financiar: "Financiar",
  achizitii: "Achiziții",
  gestionar: "Gestionar/Control cantitate",
  productie: "Producție",
  proiectare: "Proiectare",
  logistica: "Logistică",
  planificare_montaj: "Manager planificare/montaj",
  ctc: "Control calitate",
  office_manager: "Office Manager",
  inginer_mecanic: "Inginer Mecanic",
};

export const DEPARTMENTS = [
  { key: "vanzari", label: "Vânzări" },
  { key: "office", label: "Office" },
  { key: "financiar", label: "Financiar" },
  { key: "proiectare", label: "Proiectare" },
  { key: "proiectare_structuri", label: "Proiectare Structuri" },
  { key: "asistent_vanzari", label: "Asistent Vânzări" },
  { key: "achizitii", label: "Achiziții" },
  { key: "gestiune", label: "Gestiune" },
  { key: "productie", label: "Producție" },
  { key: "ctc", label: "CTC" },
  { key: "logistica", label: "Logistică" },
  { key: "montaj", label: "Montaj" },
  { key: "inginer_mecanic", label: "Inginer Mecanic" },
];

export const STAGES = [
  { value: "nou", label: "Nou" },
  { value: "calificat", label: "Calificat" },
  { value: "oferta", label: "Ofertă" },
  { value: "negociere", label: "Negociere" },
  { value: "castigat", label: "Câștigat" },
  { value: "pierdut", label: "Pierdut" },
];

export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.value, s.label]));

// Culori per etapă pipeline (mapare vizuală din referință)
export const STAGE_COLORS = {
  nou: { text: "text-blue-400", border: "border-blue-500/60", pill: "bg-blue-500/10 text-blue-400 border border-blue-500/20", statusLabel: "NOU" },
  calificat: { text: "text-fuchsia-400", border: "border-fuchsia-500/60", pill: "bg-fuchsia-500/10 text-fuchsia-300 border border-fuchsia-500/20", statusLabel: "CALIFICAT" },
  oferta: { text: "text-amber-400", border: "border-amber-500/60", pill: "bg-amber-500/10 text-amber-400 border border-amber-500/20", statusLabel: "OFERTĂ" },
  negociere: { text: "text-orange-400", border: "border-orange-500/60", pill: "bg-orange-500/10 text-orange-400 border border-orange-500/20", statusLabel: "NEGOCIERE" },
  castigat: { text: "text-emerald-400", border: "border-emerald-500/60", pill: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20", statusLabel: "CÂȘTIGAT" },
  pierdut: { text: "text-red-400", border: "border-red-500/60", pill: "bg-red-500/10 text-red-400 border border-red-500/20", statusLabel: "PIERDUT" },
};

export const ACTIVITY_META = {
  apel: { label: "Apel", cls: "bg-blue-500/10 text-blue-400" },
  email: { label: "Email", cls: "bg-emerald-500/10 text-emerald-400" },
  intalnire: { label: "Întâlnire", cls: "bg-amber-500/10 text-amber-400" },
  nota: { label: "Notă", cls: "bg-violet-500/10 text-violet-300" },
  task: { label: "Task", cls: "bg-white/10 text-muted-foreground" },
};

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("ro-RO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
}

export function dateKey(s) {
  try { return new Date(s).toLocaleDateString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return "—"; }
}

export const MILESTONES = [
  { code: "G0", label: "Go comercial" },
  { code: "G1", label: "Proiect inițiat" },
  { code: "G2", label: "Date tehnice complete" },
  { code: "G3", label: "Design aprobat" },
  { code: "G4", label: "Materiale disponibile" },
  { code: "G5", label: "Producție eliberată" },
  { code: "G6", label: "Ready to mobilize" },
  { code: "G7", label: "Montaj finalizat" },
  { code: "G8", label: "Recepție" },
  { code: "G9", label: "Închidere" },
];

export const RISK = {
  verde: { label: "Verde", cls: "bg-emerald-500", text: "text-emerald-400", ring: "ring-emerald-500/30" },
  galben: { label: "Galben", cls: "bg-amber-500", text: "text-amber-400", ring: "ring-amber-500/30" },
  rosu: { label: "Roșu", cls: "bg-red-500", text: "text-red-400", ring: "ring-red-500/30" },
};

export const PROJECT_STATUS = {
  activ: "Activ",
  on_hold: "În așteptare",
  finalizat: "Finalizat",
  anulat: "Anulat",
};

export const ROLE_HOME_DEFAULTS = { inginer: "design", pm: "productie" };

export const MODULE_LIST = [
  { key: "/leads", label: "Lead-uri" },
  { key: "/pipeline", label: "Pipeline" },
  { key: "/activities", label: "Activități" },
  { key: "/performance", label: "Performanță" },
  { key: "/projects", label: "Proiecte" },
  { key: "/previziuni", label: "Previziuni" },
  { key: "/parc-auto", label: "Parc Auto" },
  { key: "/echipamente", label: "Echipamente & Utilaje" },
  { key: "/carnet-service", label: "Carnet Service & Mentenanță" },
  { key: "/concedii", label: "CO & Sărbători" },
  { key: "/inventory", label: "Gestiune" },
  { key: "/finance", label: "Financiar" },
  { key: "/exec", label: "Conducere" },
  { key: "/productie", label: "Producție Rezervoare" },
  { key: "/arhiva", label: "Arhivă proiecte" },
];

// ---- Calcul module din departamente (oglindă a backend-ului departments.py) ----
const BASE_MODULES = ["/dashboard", "/", "/projects", "/activities", "/companion", "/departamente"];
const DEPT_SCREENS = {
  vanzari: ["/leads", "/pipeline", "/performance", "/previziuni"],
  office: ["/projects", "/finance", "/inventory"],
  financiar: ["/finance"],
  proiectare: ["/projects", "/visio-ai", "/inventory"],
  proiectare_structuri: ["/leads", "/projects", "/visio-ai", "/inventory"],
  asistent_vanzari: ["/leads", "/pipeline", "/projects"],
  achizitii: ["/inventory", "/previziuni"],
  gestiune: ["/inventory"],
  productie: ["/projects", "/inventory"],
  ctc: ["/projects"],
  logistica: ["/parc-auto", "/projects"],
  montaj: ["/projects", "/carnet-service"],
  inginer_mecanic: ["/echipamente", "/inventory"],
};

export function modulesForDepartments(depts) {
  const mods = new Set(BASE_MODULES);
  let list = [...(depts || [])];
  if ((list.includes("gestiune") || list.includes("productie")) && !list.includes("ctc")) list = [...list, "ctc"];
  for (const d of list) {
    mods.add(`/departamente/${d}`);
    for (const path of DEPT_SCREENS[d] || []) mods.add(path);
  }
  return [...mods].sort();
}

// ---- Reguli de acces (frontend) ----
const ADMIN_ONLY_ROUTES = ["/workflow", "/users", "/audit"];
const ALL_USERS_ROUTES = ["/", "/manual", "/companion", "/cautare-documente", "/nomenclatoare"];
const SALES_ROUTES = ["/leads", "/pipeline", "/activities", "/performance"];
const SALES_ROLES = ["vanzari", "asistent_vanzari"];

export function canAccess(user, to) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (ALL_USERS_ROUTES.includes(to)) return true;
  if (ADMIN_ONLY_ROUTES.includes(to)) return false;
  const isSales = SALES_ROLES.includes(user.role);
  if (to === "/visio-ai") return isSales;
  if (SALES_ROUTES.includes(to)) return isSales || (user.modules || []).includes(to);
  return (user.modules || []).includes(to);
}

const LANDING_ORDER = ["/", "/leads", "/pipeline", "/activities", "/performance", "/projects",
  "/previziuni", "/parc-auto", "/echipamente", "/carnet-service", "/concedii",
  "/inventory", "/finance", "/exec", "/manual", "/companion"];

export function firstAccessible(user) {
  for (const p of LANDING_ORDER) if (canAccess(user, p)) return p;
  return "/manual";
}

export const HOME_OPTIONS = [
  { key: "", label: "Dashboard general" },
  { key: "design", label: "Panou Design" },
  { key: "achizitii", label: "Panou Achiziții" },
  { key: "productie", label: "Panou Producție" },
  { key: "montaj", label: "Panou Montaj" },
  { key: "logistica", label: "Panou Logistică" },
  { key: "financiar", label: "Panou Financiar" },
];


export function fmtMoney(v) {
  const n = Number(v || 0);
  return n.toLocaleString("ro-RO", { maximumFractionDigits: 0 }) + " €";
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("ro-RO", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}
